import { Skeleton } from '@costar-ui/components';
import React from 'react';

var Skeletons = function Skeletons(_ref) {
  var _ref$num = _ref.num,
    num = _ref$num === void 0 ? 1 : _ref$num,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 'full' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '1.25' : _ref$height,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React.createElement(React.Fragment, null, Array.from({
    length: num
  }).map(function (_, index) {
    return /*#__PURE__*/React.createElement(Skeleton, {
      key: index,
      width: width,
      height: height,
      className: className
    });
  }));
};
var Skeletons$1 = Skeletons;

export { Skeletons$1 as default };
//# sourceMappingURL=skeletons.esm.js.map
